import axiosMapInstance from "../interceptor/webMapInstance";
import axiosInstance from "../interceptor/instance";

const baseUrl = `${process.env.REACT_APP_BASE_URL_WEB_MAP}/filter`;

// get unique values based on a filter query
export const getFilters = async (data, config) => {
  if(data.hint) config.params = {
    ...(config.params || {}),
    hint: data.hint
  };
  const response = await axiosMapInstance.get(
    `${baseUrl}/matched/${data.countryCode}?quarter=${data.quarter}%20${data.year}&column=${data.column}&table=${data.table}`,
    config
  );
  return response.data;
};

// get unique values with count based on a filter query and location
export const getFiltersWithLocation = async (data, config) => {
  const response = await axiosInstance.get(
    `${baseUrl}/count/view-port/${data.countryCode}${data.adL ? "/" + data.adL + "/" + data.adLVal : ""}?quarter=${data.quarter}%20${data.year}${!data.adL ? "&northEast=" + data.northEast + "&southWest=" + data.southWest : ""}&column=${data.column}&table=${data.table}`,
    config
  );
  return response.data;
};

// get all possible unique values regardless of the filter query
export const getAllDistinctWithCount = async (data, config) => {
  const response = await axiosMapInstance.get(
    `${baseUrl}/all/${data.countryCode}?quarter=${data.quarter}%20${data.year}&column=${data.column}&table=${data.table}`,
    config
  );
  return response.data;
};